import type { ReportLibrarySectionOrders } from './applyReportLibraryOrder';
import { FAVORITES_SECTION_ID } from './mock/reports';

const STORAGE_KEY = 'frontdoor_report_library_section_orders';
const SECTION_IDS_KEY = 'frontdoor_report_library_section_ids';

// TODO(db): Replace this localStorage helper (and reportFavoritesStorage) with a
// per-user `user_report_library_pref` table + GET/PUT
// `/apiv2/users/me/report-library-pref`. Persist
// `{ favoriteReportIds, sectionOrders, sectionIds }` and merge saved ids with
// the catalog: keep known order, append new reports/sections, drop removed ids,
// and always pin favorites first. Scope is per user (same across events).

export function getStoredReportLibrarySectionOrders(): ReportLibrarySectionOrders {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            return {};
        }

        const parsed: unknown = JSON.parse(stored);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return {};
        }

        const orders: ReportLibrarySectionOrders = {};

        for (const [sectionId, value] of Object.entries(parsed)) {
            if (!Array.isArray(value)) {
                continue;
            }

            const reportIds = value.filter((id): id is string => typeof id === 'string');
            if (reportIds.length > 0) {
                orders[sectionId] = reportIds;
            }
        }

        return orders;
    } catch {
        return {};
    }
}

export function setStoredReportLibrarySectionOrders(orders: ReportLibrarySectionOrders): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(orders));
}

export function getStoredReportLibrarySectionIds(): string[] {
    try {
        const stored = localStorage.getItem(SECTION_IDS_KEY);
        if (!stored) {
            return [];
        }

        const parsed: unknown = JSON.parse(stored);
        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed.filter(
            (id): id is string => typeof id === 'string' && id !== FAVORITES_SECTION_ID,
        );
    } catch {
        return [];
    }
}

export function setStoredReportLibrarySectionIds(sectionIds: string[]): void {
    const next = sectionIds.filter((id) => id !== FAVORITES_SECTION_ID);
    localStorage.setItem(SECTION_IDS_KEY, JSON.stringify(next));
}
